import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { ImprintPageFeature } from '@hyundai/ng-common-lib';
import { EditableDirective } from '@hyundai/ng-edit-lib';
import { Store } from '@ngrx/store';
import { SubNavLegalComponent } from '../sub-nav-legal/sub-nav-legal.component';

@Component({
    selector: 'app-imprint-page',
    standalone: true,
    styleUrls: ['./imprint-page.component.scss'],
    imports: [EditableDirective, SubNavLegalComponent],
    templateUrl: './imprint-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImprintPageComponent {
    protected readonly store = inject(Store);

    content = this.store.selectSignal(ImprintPageFeature.state.selectLoadedContent);
}
